var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"dad u__text-center"},[_c('draggable',_vm._b({class:[
			{
				'is-updating': _vm.isUpdating
			},
			'u__margin-top-30',
			'content'
		],model:{value:(_vm.projects),callback:function ($$v) {_vm.projects=$$v},expression:"projects"}},'draggable',_vm.options,false),_vm._l((_vm.projects),function(project){return _c('div',{key:project.id,staticClass:"photo filter",style:([
				{
					background: 'url(' + _vm.$getImgUrl(_vm.getName(project.mainImageId)) + ')'
				},
				{ 'background-size': 'cover' },
				{ 'background-repeat': 'no-repeat' }
			])},[_c('router-link',{staticClass:"link-edit",attrs:{"to":("/edit-projects/" + (project.id))}},[_vm._v(" "+_vm._s(project.order)+" ")])],1)}),0),_c('div',{staticClass:"photo filter"},[_c('img',{staticClass:"image",attrs:{"src":_vm.$getImgUrl('dodaj.jpg')}}),_c('router-link',{staticClass:"link-edit",attrs:{"to":"/edit-projects/add"}},[_vm._v(" dodaj ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }